<div class="h-100 box d-flex flex-column px-2 pb-5">
    <div class="px-4">
        <div class="text-l font-semi-bold border-b border-dark py-5">{{ 'v3-byoc-popup-create-course-title' | translate }}</div>
    </div>

    <div class="flex-grow-1">
        <div class="py-4 px-4 relative inner">
            <div class="mb-4 font-semi-bold text-default text-s">
                <span translate>v3-byoc-popup-create-course-mission-title</span><span translate> v3-global-or </span>
                <span appByocCreateMission [isSubmodal]="true" (click)="createCourseClick()" class="text-info create-mission-link" translate
                    >v3-byoc-popup-create-course-mission-link</span
                >
            </div>

            <div class="mb-4">
                <app-forms-input
                    [control]="searchFormControl"
                    icon="lens"
                    classes="info"
                    [placeholder]="'v3-byoc-popup-create-course-mission-input-placeholder' | translate"
                    formControlDataTest="search"
                ></app-forms-input>
            </div>

            <div class="d-flex align-items-center mb-4">
                <div class="me-4">
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input
                            id="form-radio-origin-0"
                            type="radio"
                            [formControl]="originControl"
                            [value]="0"
                            name="form-radio-origin"
                            formControlDataTest="allMissions"
                        />
                        <label for="form-radio-origin-0" class="text-odd-xxs text-uppercase">
                            {{ 'v3-global-all' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
                <div class="me-4">
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input
                            id="form-radio-origin-1"
                            type="radio"
                            [formControl]="originControl"
                            [value]="1"
                            name="form-radio-origin"
                            formControlDataTest="stMissions"
                        />
                        <label for="form-radio-origin-1" class="text-odd-xxs text-uppercase">
                            {{ 'v3-byoc-popup-create-course-mission-radio-st-missions' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
                <div>
                    <!-- Radio -->
                    <div class="radio radio-success">
                        <input
                            id="form-radio-origin-2"
                            type="radio"
                            [formControl]="originControl"
                            [value]="2"
                            name="form-radio-origin"
                            formControlDataTest="customMissions"
                        />
                        <label for="form-radio-origin-2" class="text-odd-xxs text-uppercase">
                            {{ 'v3-byoc-popup-create-course-mission-radio-custom-missions' | translate }}
                            <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                        </label>
                    </div>
                </div>
            </div>

            <app-byoc-course-step-mission-list
                #missionsList
                [onHold]="creatingMission"
                [searchFormControl]="searchFormControl"
                [originControl]="originControl"
            ></app-byoc-course-step-mission-list>
        </div>
    </div>

    <div class="theme-new d-flex align-items-center px-4">
        <button (click)="cancelClick()" class="btn btn-primary ms-auto" translate buttonDataTest="cancelButton">v3-button-cancel</button>
        <button (click)="backClick()" class="btn btn-primary" translate buttonDataTest="backButton">v3-button-back</button>

        <ng-container *ngIf="selectedMissionLength > 1; else emptyMissionButtons">
            <button
                [disabled]="!missionIdControl.valid || processing"
                (click)="nextClick()"
                class="btn o-hidden"
                [ngClass]="[missionIdControl.valid && !processing ? 'btn-secondary' : 'btn-disabled']"
                buttonDataTest="continueButton"
            >
                <span translate>v3-button-continue</span>
                <app-loader *ngIf="processing" loaderType="button" loaderColor="white" overlayColor="info"></app-loader>
            </button>
        </ng-container>
    </div>
</div>

<ng-template #emptyMissionButtons>
    <button
        (click)="saveAndAddClick()"
        [disabled]="!missionIdControl.valid || processing"
        class="btn o-hidden"
        [ngClass]="[!processing && missionIdControl.valid ? 'btn-secondary' : 'btn-disabled']"
        buttonDataTest="saveAndAddButton"
    >
        <span translate>v3-button-save-and-add-learning-item</span>
        <app-loader *ngIf="processing" loaderType="button" loaderColor="white" overlayColor="darkest" loaderSize="s"></app-loader>
    </button>
    <button
        (click)="saveClick()"
        [disabled]="!missionIdControl.valid || processing"
        class="btn o-hidden"
        [ngClass]="[!processing && missionIdControl.valid ? 'btn-secondary' : 'btn-disabled']"
        buttonDataTest="saveButton"
    >
        <span translate>v3-button-save</span>
        <app-loader *ngIf="processing" loaderType="button" loaderColor="white" overlayColor="info" loaderSize="s"></app-loader>
    </button>
</ng-template>
